const PROFILE_KEY = 'profile'
const SELLERS_KEY = 'sellers'
const BUYERS_KEY = 'buyers'
const OUTLETS_KEY = 'outlets'
const REGISTRATIONS_KEY = 'registrations'
const MOTIVATIONS_KEY = 'motivations'
const REPORTS_KEY = 'reports'
const PAYMENTS_KEY = 'payments'
const GOODS_REMAINING_KEY = 'goods-remaining'
const PUBLICATIONS_KEY = 'publications'
const ANALYTICS_KEY = 'analytics'
const NOT_FOUND_KEY = 'not-found'
const ACCESS_DENIED_KEY = 'access-denied'

export const GET_BREADCRUMBS_INNER_LABELS = $t => ({
  [PROFILE_KEY]: $t('Profile'),
  [SELLERS_KEY]: $t('Sellers'),
  [BUYERS_KEY]: $t('Buyers'),
  [OUTLETS_KEY]: $t('Outlets'),
  [REGISTRATIONS_KEY]: $t('Registrations'),
  [MOTIVATIONS_KEY]: $t('Motivations'),
  [REPORTS_KEY]: $t('Sellers reports'),
  [PAYMENTS_KEY]: $t('Payments'),
  [GOODS_REMAINING_KEY]: $t('Goods remaining'),
  [PUBLICATIONS_KEY]: $t('Publications'),
  [ANALYTICS_KEY]: $t('Analytics'),
  [NOT_FOUND_KEY]: $t('Not Found'),
  [ACCESS_DENIED_KEY]: $t('Access Denied'),
})